// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".margin-bottom-10[data-v-5822c6aa] {\n  margin-bottom: 10px;\n}\n.right[data-v-5822c6aa] {\n  text-align: right;\n}\n[data-v-5822c6aa] .page-pageination {\n  text-align: right;\n  padding: 10px 0;\n}\n[data-v-5822c6aa] .page-pageination .el-input {\n  display: inline-block !important;\n}\n", ""]);
// Exports
module.exports = exports;
